import React from "react";
import styled from "styled-components";
import apartmentImg from "../../assets/images/apartments.png";

const AboutSection = () => {
  return (
    <SectionWrapper>
      <Container>
        <ContentWrapper>
          <ImageWrapper>
            <AboutImage src={apartmentImg} alt="About Us" />
          </ImageWrapper>
          <TextWrapper>
            <Title> Who We Are– Springfield Properties </Title>
            <Description>
              We are a forward - thinking company dedicated to delivering high -
              quality solutions.Our passion lies in innovation, customer
              satisfaction, and creating lasting impact.With a team committed to
              excellence, we aim to transform ideas into remarkable results that
              inspire and empower We are a forward - thinking company dedicated
              to delivering high - quality solutions.Our passion lies in
              innovation, customer satisfaction, and creating lasting
              impact.With a team committed to excellence, we aim to transform
              ideas into remarkable results that inspire and empower.
            </Description>
          </TextWrapper>
        </ContentWrapper>
      </Container>
    </SectionWrapper>
  );
};

export default AboutSection;

// ------------------ Styled Components ------------------

const SectionWrapper = styled.div`
  background-color: #f8f8f8;
  padding: 110px 0px;

   @media (max-width: 768px) {
    padding-bottom: 0px;
  }
    
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }
`;

const AboutImage = styled.img`
  max-width: auto;
  height: auto;
`;

const TextWrapper = styled.div`
  flex: 1;
  padding: 20px;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
  font-family: "Paris Avenue";
  color: #222;

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

const Description = styled.p`
  font-size: 1.25rem;
  line-height: 1.8;
  color: #555;
  font-weight: 300;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;
